import React, { Component } from "react";
import {Modal} from 'react-bootstrap';
import ViewTemplate from "./ViewTemplate";
import ReAssign from './ReAssign.js'
import _ from 'lodash';
export default class ModalWindow  extends Component {
  render(){
    const{link, auditorJson, isview} = this.props;
    return(
      <Modal
      show={true}
      onHide={this.props.closeModal}
      dialogClassName={(link) ? "modal-90w " :"modal-120w clientrecordxl"}
      size={(link) ? "lg" :"xl"}
     //aria-labelledby="contained-modal-title-vcenter"
      centered
      >
      <Modal.Header closeButton>
      <Modal.Title id="example-custom-modal-styling-title">
      {link ? "Replace Template" : isview ?  <span>{'View Template --'+auditorJson.templateName}</span>
      : <span>{'View Template --'+auditorJson.templateName+' ['+
      auditorJson.region.regionName+' / '+_.map(auditorJson.center, (item, index) => {return item.centerName }).join(",")+' / '+
      _.map(auditorJson.client, (item,index1) => { return item.clientName }).join(",")+' / '+
      _.map(auditorJson.process, (item,index2) => {return item.processName }).join(",")+' ]'
      }</span>}
      </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      {link  ?
        <ReAssign function={this.props.function}   data={this.props.data} closeModal={this.props.closeModal}
        nameList={this.props.nameList}/>
      :<ViewTemplate templatepayload={this.props.auditorJson} formread={true} dataList={this.props.dataList}
      closeModal={this.props.closeModal}/>}</Modal.Body>
      </Modal>

    )
  }
}

